import "./Glance.css";

function Glance() {
  return (
    <div>
      <p style={{ marginBottom: 12 }}>
        Strategic engineering leader and people manager with a strong track
        record of guiding cross-functional teams, shaping product roadmaps, and
        driving innovation through intelligent software systems. Skilled in
        full-stack development, system design, and leading teams to scale.
        Focused on delivering high-impact software through technical rigor,
        exceptional leadership, and empathy-first communication.
      </p>
      <p>
        <span className="Glance-heading">Languages:</span>
        &nbsp;JavaScript, TypeScript, Python, C++, Java, Kotlin, HTML & CSS
      </p>
      <p>
        <span className="Glance-heading">Tools/Platforms:</span>
        &nbsp;Vercel, GitHub Actions, AWS, GCP, Jenkins, Playwright, Cypress
      </p>
      <p>
        <span className="Glance-heading">Frameworks/Libraries:</span> NextJS,
        ReactJS, AngularJS, Node.js, Django, React Native, Material UI
      </p>
      <p style={{ marginBottom: 12 }}>
        <span className="Glance-heading">Databases:</span> NeonDB, Firebase,
        Postgres, MySQL, MongoDB
      </p>
      <span className="Glance-heading">Areas of Expertise:</span>
      <ul className="Glance-areas-of-expertise">
        <li>Team Management</li>
        <li>Technical Leadership</li>
        <li>AI-Powered Tooling</li>
        <li>End-to-end Product Architecture</li>
        <li>Strategic Planning & Direction</li>
        <li>Process Optimization</li>
        <li>Product Roadmap Development</li>
        <li>Software Engineer Mentorship</li>
      </ul>
    </div>
  );
}

export default Glance;
